
import { Component, Prop, Vue } from "vue-property-decorator";
import FillerPicker from "../FillerPicker.vue";
import { StripEditorModel } from "./StripModel";

@Component({
  components: {
    FillerPicker,
  },
})
export default class StripMainEditor extends Vue {
  @Prop() value!: StripEditorModel;

  update(): void {
    if (
      this.value.outlineType == "gemel-potented" &&
      this.value.size !== "gemel"
    ) {
      this.value.outlineType = "straight";
    }

    this.$emit("input", this.value);
  }
}
